module.exports = __webpack_public_path__ + "img/polling.decfbe08.svg";